import { render, staticRenderFns } from "./ChefHat.vue?vue&type=template&id=1dc54a3e"
import script from "./ChefHat.vue?vue&type=script&lang=js"
export * from "./ChefHat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports